import type { Event } from '../../api/events/types'

/**
 * Sort events array by startDate
 * Future Events should be shown at the top, where the first event is the closest one
 * Past events are shown at the bottom where the last event is the oldest one
 */
export const sortEventsByDate = (events: Array<Partial<Event> | Event>): Array<Partial<Event> | Event> => {
  const now = new Date()

  const pastEvents = events.filter(event => event.endDate && new Date(event.endDate) < now)
  const futureEvents = events.filter(event => event.endDate && new Date(event.endDate) >= now)

  futureEvents.sort((a, b) => new Date(a.startDate!).getTime() - new Date(b.startDate!).getTime())
  pastEvents.sort((a, b) => new Date(b.startDate!).getTime() - new Date(a.startDate!).getTime())

  return [...futureEvents, ...pastEvents]
}
